import axios              from 'axios';
import authHeader         from 'services/auth-header';
import walletUnlockHeader from 'services/wallet-unlock-header';

class WalletService  {
  transactions(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'payment/wallet_transactions?' + parameters, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  downloadCsv(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'payment/wallet_transactions.csv?' + parameters, { headers: authHeader(), responseType: 'blob' })
      .then(response => {
        return response.data;
      }
    );
  }

  withdraw(parameters) {
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'payment/wallet_transactions/withdraw', parameters, { headers: walletUnlockHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  listBanks() {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'payment/wallet_transactions/list_banks', { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new WalletService();
